var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticStyle: { width: "100%" },
    attrs: {
      items: _vm.pendingItems,
      "hide-default-footer": "",
      "hide-default-header": "",
      "disable-pagination": "",
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item }) {
          return [
            _c(
              "v-card",
              {
                staticClass: "mb-2",
                attrs: { outlined: "", color: "darken-1", elevation: "0" },
              },
              [
                _c(
                  "v-card-actions",
                  { staticClass: "ma-0 pa-0" },
                  [
                    _c(
                      "v-card-text",
                      { staticClass: "blue--text ma-0 pa-0 ml-2 mt-0" },
                      [_vm._v(_vm._s(item))]
                    ),
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mt-0 mr-1",
                        attrs: { icon: "", color: "red" },
                        on: {
                          click: function ($event) {
                            return _vm.onPressDelete(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-delete")])],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-card-actions",
                  { staticClass: "ma-0 pa-0" },
                  [
                    _c("v-autocomplete", {
                      staticStyle: {
                        "margin-bottom": "-20px",
                        "margin-left": "8px",
                        "margin-right": "8px",
                      },
                      attrs: {
                        label: "Aud",
                        dense: "",
                        items: _vm.audiences,
                        outlined: "",
                        "item-text": "name",
                        "item-value": "name",
                        "return-object": "",
                        "small-chips": "",
                        "deletable-chips": "",
                        multiple: true,
                      },
                      model: {
                        value: _vm.aud[item],
                        callback: function ($$v) {
                          _vm.$set(_vm.aud, item, $$v)
                        },
                        expression: "aud[item]",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }